import React from 'react';
import CustomLink from 'components/shared/CustomLink';
import { CustomImage as Image } from '..';
import { BannerText } from './styleConstants';
import styles from './PreFooterBanner.module.css';

const cx = (...parts: (string | false | undefined)[]) =>
  parts.filter(Boolean).join(' ');

const PreFooterBanner = ({ className }: { className?: string }) => {
  return (
    <section className={cx(styles.preFooterBanner, className)}>
      <CustomLink href="/diesel-ultrahuman-ring/buy" aria-label="Shop now">
        <Image
          src="web_v2/uh-x-diesel/pre-footer-banner-v1.png/w_1920"
          alt="Diesel Girl Portrait"
          height={1920}
          width={1670}
        />
        <div className={styles.textContent}>
          <BannerText $color="d_red">SHOP</BannerText>
          <BannerText $color="d_red">NOW</BannerText>
        </div>
      </CustomLink>
    </section>
  );
};

export default PreFooterBanner;
